import React, { useEffect, useState } from "react";
import { Circle, CustomOverlayMap, Map, MapMarker, MapTypeControl } from "react-kakao-maps-sdk";

import * as TypeDTO from "../commons/typeDTO";

import chaeviBlue from "../assets/images/digitalKeyController/stn-chaevi-blue.svg";
import chaeviYellow from "../assets/images/digitalKeyController/stn-chaevi-yellow.svg";
import skBlue from "../assets/images/digitalKeyController/stn-sk-blue.svg";
import skYellow from "../assets/images/digitalKeyController/stn-sk-yellow.svg";

import styles from "./KakaoMapEVStation.module.css";

export type gpsType = {
    lat: number;
    lng: number;
};

function KakaoMapEVStation({
    mapStyle,
    zoomLevel,
    mapCenter,
    myPosition,
    selectedStation,
    evcs,
    onClickEvStation,
    onChangedMapCenter,
    onChangedZoomLevel,
}: {
    mapStyle?: React.CSSProperties;
    zoomLevel?: number;
    mapCenter?: gpsType;
    myPosition?: gpsType;
    selectedStation?: TypeDTO.EvcsItemDto;
    evcs?: Array<TypeDTO.EvcsItemDto>;
    onChangedZoomLevel?: (level: number) => void;
    onChangedMapCenter?: (lat: number, lng: number) => void;
    onClickEvStation?: (station: TypeDTO.EvcsItemDto) => void;
}) {
    const [kakaoMap, setKakaoMap] = useState<kakao.maps.Map | undefined>(undefined);
    const [level, setLevel] = useState<number>(12);
    const [center, setCenter] = useState<gpsType>();
    // const [mapBounds, setMapBounds] = useState<kakao.maps.LatLngBounds>(new kakao.maps.LatLngBounds());
    // const [selectedAddress, setSelectedAddress] = useState<string>("");

    useEffect(() => {
        zoomLevel !== undefined && setLevel(zoomLevel);
    }, [zoomLevel]);

    useEffect(() => {
        setCenter(mapCenter);
    }, [mapCenter]);

    useEffect(() => {
        if (kakaoMap !== undefined && center !== undefined) {
            kakaoMap.setCenter(new kakao.maps.LatLng(center.lat, center.lng));
            // kakaoMap.panTo(new kakao.maps.LatLng(center.lat, center.lng));
        }
    }, [center]);

    // useEffect(() => {
    //     if (kakaoMap !== undefined && mapBounds.isEmpty() === false) {
    //         kakaoMap.setBounds(mapBounds);
    //     }
    // }, [kakaoMap, mapBounds]);

    const onZoomChanged = (map: kakao.maps.Map) => {
        setLevel(map.getLevel());

        if (onChangedZoomLevel !== undefined) onChangedZoomLevel(map.getLevel());
    };

    const onCenterChanged = (map: kakao.maps.Map) => {
        setCenter({ lat: map.getCenter().getLat(), lng: map.getCenter().getLng() });
        onChangedMapCenter && onChangedMapCenter(map.getCenter().getLat(), map.getCenter().getLng());
    };

    const handleMap = (map: kakao.maps.Map) => {
        setKakaoMap(map);
    };

    const displayMyPostion = () => {
        if (myPosition === undefined) return null;

        return (
            <>
                <CustomOverlayMap
                    position={{
                        lat: myPosition.lat,
                        lng: myPosition.lng,
                    }}
                >
                    <div className={styles.myLocationShadow} />
                </CustomOverlayMap>
                <CustomOverlayMap
                    position={{
                        lat: myPosition.lat,
                        lng: myPosition.lng,
                    }}
                >
                    <div className={styles.myLocationDot} />
                </CustomOverlayMap>
            </>
        );

        // return (
        //     <div>
        //         <Circle
        //             center={myPosition}
        //             radius={30}
        //             strokeWeight={1} // 선의 두께입니다
        //             strokeColor={"#ff0000"}
        //             strokeOpacity={0.3}
        //             fillColor={"#ff0000"} // 채우기 색깔입니다
        //             fillOpacity={0.3} // 채우기 불투명도 입니다
        //             zIndex={5}
        //         />
        //         <Circle
        //             center={myPosition}
        //             radius={15}
        //             strokeWeight={3} // 선의 두께입니다
        //             strokeColor={"#ffffff"}
        //             strokeOpacity={1}
        //             fillColor={"#447dee"} // 채우기 색깔입니다
        //             fillOpacity={1} // 채우기 불투명도 입니다
        //             zIndex={5}
        //         />
        //     </div>
        // );
    };

    const displayEvStations = () => {
        if (evcs === undefined) return null;

        return evcs.map((station) => {
            let selected = false;
            if (selectedStation !== undefined && station.statId === selectedStation.statId) {
                selected = true;
            }

            let imageSrc = "";
            if (selected) {
                imageSrc = station.busiId === "CV" ? chaeviYellow : skYellow;
            } else {
                imageSrc = station.busiId === "CV" ? chaeviBlue : skBlue;
            }
            return (
                <MapMarker
                    key={station.statId + "_" + station.chgerId}
                    position={{
                        lat: station.lat,
                        lng: station.lng,
                    }}
                    image={{
                        src: imageSrc,
                        size: {
                            width: 24,
                            height: 30,
                        },
                    }}
                    onClick={(marker: kakao.maps.Marker) => {
                        if (onClickEvStation !== undefined) onClickEvStation(station);
                    }}
                />
            );
        });
    };

    return (
        <>
            <Map
                center={mapCenter === undefined ? { lat: 35.85810060700929, lng: 128.55729938820272 } : mapCenter}
                onCreate={(map) => handleMap(map)}
                style={mapStyle}
                level={level}
                isPanto={true}
                onZoomChanged={(map) => onZoomChanged(map)}
                onCenterChanged={(map) => onCenterChanged(map)}
            >
                <MapTypeControl position={kakao.maps.ControlPosition.TOPRIGHT} />
                {myPosition && displayMyPostion()}
                {evcs && displayEvStations()}
            </Map>
        </>
    );
}

export default KakaoMapEVStation;
